<template>
  <div class="body">
   <section class="content">
      <div class="box box-info">
        <Toast style="margin-top: 35px" />
        <form class="form-horizontal">
          <Button class="btn btn-primary" style="margin: 0% 106%;" type="button" @click="openAddDialog" >
              <i class="fa fa-plus-circle" aria-hidden="true"></i>
          </Button>
          <Dialogs header="USER" :visible.sync="showDialog"
           :style="{width: '50vw'}" :modal="true" :closable="false" :contentStyle="{'overflow': 'visible'}">

          <form class="form-horizontal">
          <div style="margin: 0% -25% 3% 28%;">
            <div class="form-group">
              <label for="accountHead" class="col-sm-3 control-label">Name</label>
                <input
                  type="text"
                  v-model.trim="name"
                  class="form-control col-sm-2 "
                  id="accountHead"/>
            </div>
            <div class="form-group" v-if="!this.editing">
              <label for="username" class="col-sm-3 control-label">Username</label>
                <input
                  type="text"
                  v-model.trim="userName"
                  class="form-control col-sm-2 "
                  id="username" />
            </div>
              <div class="form-group" v-if="!this.editing">
              <label for="password" class="col-sm-3 control-label">Password</label>
                <input
                  type="password"
                  v-model.trim="password"
                  class="form-control col-sm-2 "
                  id="password"/>
            </div>
              <div class="form-group" v-if="!this.editing">
              <label for="password1" class="col-sm-3 control-label">Re-password</label>
                <input
                  type="password"
                  v-model.trim="password1"
                  class="form-control col-sm-2  "
                  id="password1"/>
            </div>
          </div>
          </form>
           <div style="margin: 5% 0% 0% 38%;">
            <button class="btn btn-primary pull-left"
            @click.prevent="addUser"
             style="margin-right:5px;">{{!this.editing?'Add':'Update'}}</button>
            <button  @click.prevent="cancelAdd" class="btn btn-danger">Cancel</button>
          </div>
          </Dialogs>
        </form>
            <DataTable :value="userLists" :paginator="true" :rows="8"
    class="p-datatable-responsive p-datatable-customers" data-key="id">
      <Column header="S.n" field="id"/>
      <Column header="Name" field="name" filterField="name" filterMatchMode="contains" />
      <Column header="Username" field="username" filterField="username" filterMatchMode="contains"/>
      <!-- <Column header="Role" field="role" filterField="role" filterMatchMode="contains"/> -->
      <Column header="Action">
      <template #empty>No record found</template>
      <template #body="slotProps">
        &nbsp;<Button type="button" class="btn btn-success" @click ="openEditDialog(slotProps.data)">
          <i class="fa fa-edit"/></Button>
        &nbsp;&nbsp;
         <Button type="button" class="btn btn-danger"
         @click="openDialog(slotProps.data.id)"><i class="fa fa-trash"/></Button>
      </template>
      </Column>
    </DataTable>
        <!-- <userList @deleteAdminUser="deleteAdminUser" @edit-user="updateUser"/> -->
      <Dialog v-model="dialogShow" @deleted="deleteAdminUser"/>
      </div>
  </section>
  </div>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Dialogs from 'primevue/dialog'
import Dialog from '../../layout/dialog'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Toast from 'primevue/toast'
export default {
  name: 'userCreate',
  data() {
    return {
      name: '',
      roleId: '',
      userName: '',
      editing: false,
      password: '',
      password1: '',
      showDialog: false,
      dialogShow: false,
      addDisplayBasic: false,
      userId: null,
      loading: false
    }
  },
  computed: {
    userLists() {
      return this.$store.state.admin.adminUserLists
    }
  },
  mounted() {
    this.userList()
  },
  methods: {
    async addUser() {
      let response = ''
      if (this.name.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Data must not be empty!', life: 10000})
        return
      }
      if (!this.editing) {
        if (this.passowrd.trim !== this.password1.trim) {
          this.$toast.add({severity: 'error', summary: '', detail: 'Password did not match!', life: 10000})
          return
        }
      }
      let user = {
        name: this.name,
        username: this.userName,
        password: this.password1,
        userId: this.userId
      }
      if (!this.editing) {
        this.loading = true
        response = await this.$store.dispatch('createAdminUser', user)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updateAdminUser', user)
        this.loading = false
      }
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
      this.closeDialog()
    },
    async userList() {
      await this.$store.dispatch('loadAdminUser')
    },
    async deleteAdminUser(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = false
        return
      }
      let deleteReason = {
        userId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteAdminUser', deleteReason)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
      this.closeDialog()
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.showDialog = false
    },
    openEditDialog(data) {
      this.editing = true
      this.userId = data.id
      this.editing = true
      this.name = data.name
      this.userName = data.userName
      this.openAddDialog()
    },
    cancel() {
      this.dialogShow = false
    },
    updateUser(data) {
      this.name = data.name
      this.userName = data.username
      this.roleId = data.role
      this.editing = !this.editing
      this.showDialog = !this.showDialog
      this.userId = data.id
    },
    openAddDialog() {
      this.showDialog = true
    },
    cancelAdd() {
      this.name = ''
      this.userName = ''
      this.roleId = ''
      this.password = ''
      this.password1 = ''
      this.showDialog = false
      this.editing = false
    },
    resetResponse() {
      this.response = ''
      this.roleId = ''
    }
  },
  components: {
    Dropdown,
    Dialog,
    Dialogs,
    Column,
    DataTable,
    Toast
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">

</style>



// WEBPACK FOOTER //
// adminUser.vue?76767124